module.exports = __webpack_public_path__ + "static/media/failed.0451fdad.svg";